import { Component } from '@angular/core';
import { PatientInteractionLocationsExplainerComponent } from '../../../shared/components/patient-interaction-locations-explainer/patient-interaction-locations-explainer.component';
import { PatientInteractionLocationsNewLocationsSectionComponent } from '../../components/patient-interaction-locations-new-locations-section/patient-interaction-locations-new-locations-section.component';
import { PatientInteractionLocationsCurrentLocationsSectionComponent } from '../../components/patient-interaction-locations-current-locations-section/patient-interaction-locations-current-locations-section.component';

@Component({
    selector: 'app-client-portal-patient-interaction-locations',
    templateUrl: './client-portal-patient-interaction-locations.component.html',
    imports: [PatientInteractionLocationsExplainerComponent,
              PatientInteractionLocationsNewLocationsSectionComponent,
              PatientInteractionLocationsCurrentLocationsSectionComponent]
})
export class ClientPortalPatientInteractionLocationsComponent {
}
